import React, { createContext, useMemo, useState } from 'react';
import { ActionStatus, IContext, MfaActionType, MfaType } from './types';
import { StepSwitch } from './components/StepSwitch';
import { MFA_STEPS_MAP } from './helpers/constants';
import { ReactComponent as MfaBackButton } from '../../assets/svg/mfabackbutton.svg';
import { IServerErrorResponse } from '../../types';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import { useStore } from '../../store';

interface IProps {
  mfaActionData: {
    actionData: any;
    status: ActionStatus;
    mfaTypesOptions: [MfaType] | MfaType[];
    actionType: MfaActionType;
    mfaType: MfaType;
    mfaDestination: string;
  };
  onSuccess: (data?: any) => void;
  onExternalFlowError: (errData: IServerErrorResponse) => void;
  handleBackClick?: () => void;
  useNewDesign?: boolean;
}

export const MfaContext = createContext<IContext | null>(null);

export const MFA = ({ mfaActionData, onSuccess, onExternalFlowError, handleBackClick, useNewDesign }: IProps) => {
  const [activeStep, setActiveStep] = useState<number>(MFA_STEPS_MAP.INTRO);
  const [isTrustSelected, setIsTrustSelected] = useState<boolean>(false);
  const [localMfaType, setLocalMfaType] = useState<any>(mfaActionData?.mfaType || MfaType.SMS);
  const contextType = useStore((state) => state.contextType);
  const billId = useStore((state) => state.billId);

  const reqOtpPayload = useMemo(() => ({ ...mfaActionData, mfaType: localMfaType }), [localMfaType, mfaActionData]);

  const contextData = useMemo(
    () => ({
      isTrustSelected,
      setIsTrustSelected,
      setActiveStep,
      setLocalMfaType,
      onSuccess,
      onExternalFlowError,
      reqOtpPayload,
      contextType,
      billId,
    }),
    [isTrustSelected, reqOtpPayload],
  );

  const onBackClick = () => {
    if (activeStep === MFA_STEPS_MAP.RESEND) setActiveStep(MFA_STEPS_MAP.INTRO);
    if (handleBackClick && activeStep !== MFA_STEPS_MAP.RESEND) handleBackClick();
  };

  return (
    <MfaContext.Provider value={contextData}>
      {useNewDesign ? (
        <UserMessage
          id='mfaWrapper'
          onClick={() => {}}
          mainWrapperOverrideClassName='bg-bw02 flex justify-center fixed inset-0 h-screen w-screen bg-opacity-100 z-50'
          contentWrapperOverrideClassName='h-full w-full'
        >
          <div className='relative'>
            <MfaBackButton className='m-[64px]' onClick={onBackClick} />
            <div className='flex items-center justify-center h-full bg-bw02 w-[450px] relative mx-auto mt-[10%] mb-0'>
              <StepSwitch activeStep={activeStep} />
            </div>
          </div>
        </UserMessage>
      ) : (
        <div className='flex items-center justify-center h-full bg-bw00 min-w-[450px] relative'>
          <StepSwitch activeStep={activeStep} />
        </div>
      )}
    </MfaContext.Provider>
  );
};
